import { createFileRoute, Outlet } from "@tanstack/react-router";

// Pathless layout for /o/$slug/contracts/* — landing + wizard + detail.
export const Route = createFileRoute("/o/$slug/contracts")({
  component: () => <Outlet />,
});
